// source: pbtypes/gen/scan_planner/area_scan_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_scan_output_scan_coverage_parameters_pb = require('../../../pbtypes/gen/scan_output/scan_coverage_parameters_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_output_scan_coverage_parameters_pb);
var pbtypes_gen_scan_planner_area_scan_pass_type_pb = require('../../../pbtypes/gen/scan_planner/area_scan_pass_type_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_area_scan_pass_type_pb);
goog.exportSymbol('proto.scan_planner.AreaScanRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.AreaScanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.AreaScanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.AreaScanRequest.displayName = 'proto.scan_planner.AreaScanRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.AreaScanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.AreaScanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.AreaScanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.AreaScanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
overlap: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
sidelap: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
passType: jspb.Message.getFieldWithDefault(msg, 19, 0),
gimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
scanCoverageParameters: (f = msg.getScanCoverageParameters()) && pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.toObject(includeInstance, f),
filterWithPolygon: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
isLookupScan: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
strictGeofence: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
enableCustomLegHeading: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
customLegHeading: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
enableCustomCameraHeading: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
customCameraHeading: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.AreaScanRequest}
 */
proto.scan_planner.AreaScanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.AreaScanRequest;
  return proto.scan_planner.AreaScanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.AreaScanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.AreaScanRequest}
 */
proto.scan_planner.AreaScanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOverlap(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSidelap(value);
      break;
    case 19:
      var value = /** @type {!proto.scan_planner.AreaScanPassType.Enum} */ (reader.readEnum());
      msg.setPassType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGimbalPitch(value);
      break;
    case 8:
      var value = new pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters;
      reader.readMessage(value,pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.deserializeBinaryFromReader);
      msg.setScanCoverageParameters(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilterWithPolygon(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLookupScan(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStrictGeofence(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCustomLegHeading(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCustomLegHeading(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCustomCameraHeading(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCustomCameraHeading(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.AreaScanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.AreaScanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.AreaScanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.AreaScanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOverlap();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getSidelap();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getPassType();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getGimbalPitch();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getScanCoverageParameters();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.serializeBinaryToWriter
    );
  }
  f = message.getFilterWithPolygon();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getIsLookupScan();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getStrictGeofence();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getEnableCustomLegHeading();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getCustomLegHeading();
  if (f !== 0.0) {
    writer.writeFloat(
      15,
      f
    );
  }
  f = message.getEnableCustomCameraHeading();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getCustomCameraHeading();
  if (f !== 0.0) {
    writer.writeFloat(
      17,
      f
    );
  }
};


/**
 * optional double overlap = 1;
 * @return {number}
 */
proto.scan_planner.AreaScanRequest.prototype.getOverlap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setOverlap = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double sidelap = 2;
 * @return {number}
 */
proto.scan_planner.AreaScanRequest.prototype.getSidelap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setSidelap = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional AreaScanPassType.Enum pass_type = 19;
 * @return {!proto.scan_planner.AreaScanPassType.Enum}
 */
proto.scan_planner.AreaScanRequest.prototype.getPassType = function() {
  return /** @type {!proto.scan_planner.AreaScanPassType.Enum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.scan_planner.AreaScanPassType.Enum} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setPassType = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional double gimbal_pitch = 5;
 * @return {number}
 */
proto.scan_planner.AreaScanRequest.prototype.getGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional scan_output.ScanCoverageParameters scan_coverage_parameters = 8;
 * @return {?proto.scan_output.ScanCoverageParameters}
 */
proto.scan_planner.AreaScanRequest.prototype.getScanCoverageParameters = function() {
  return /** @type{?proto.scan_output.ScanCoverageParameters} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters, 8));
};


/**
 * @param {?proto.scan_output.ScanCoverageParameters|undefined} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
*/
proto.scan_planner.AreaScanRequest.prototype.setScanCoverageParameters = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.clearScanCoverageParameters = function() {
  return this.setScanCoverageParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.AreaScanRequest.prototype.hasScanCoverageParameters = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool filter_with_polygon = 10;
 * @return {boolean}
 */
proto.scan_planner.AreaScanRequest.prototype.getFilterWithPolygon = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setFilterWithPolygon = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool is_lookup_scan = 12;
 * @return {boolean}
 */
proto.scan_planner.AreaScanRequest.prototype.getIsLookupScan = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setIsLookupScan = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool strict_geofence = 13;
 * @return {boolean}
 */
proto.scan_planner.AreaScanRequest.prototype.getStrictGeofence = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setStrictGeofence = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool enable_custom_leg_heading = 14;
 * @return {boolean}
 */
proto.scan_planner.AreaScanRequest.prototype.getEnableCustomLegHeading = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setEnableCustomLegHeading = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional float custom_leg_heading = 15;
 * @return {number}
 */
proto.scan_planner.AreaScanRequest.prototype.getCustomLegHeading = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setCustomLegHeading = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional bool enable_custom_camera_heading = 16;
 * @return {boolean}
 */
proto.scan_planner.AreaScanRequest.prototype.getEnableCustomCameraHeading = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setEnableCustomCameraHeading = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional float custom_camera_heading = 17;
 * @return {number}
 */
proto.scan_planner.AreaScanRequest.prototype.getCustomCameraHeading = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.AreaScanRequest} returns this
 */
proto.scan_planner.AreaScanRequest.prototype.setCustomCameraHeading = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


goog.object.extend(exports, proto.scan_planner);
